export default __webpack_public_path__ + "static/media/mssql.0de8bfd4.svg";